// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__piVN3","newExpiryDate":"styles_newExpiryDate__1JhFs","footer":"styles_footer__3mZHE"};